import type { RecommendedContentType } from '../../models'

export const nonPersonalisedArticles: RecommendedContentType[] = [
  {
    __typename: 'RecommendedArticle',
    href: 'https://www.which.co.uk/reviews/new-and-used-cars/article/best-cars/top-cars-aaJ8y4F5Z8wg',
    id: 'aaJ8y4F5Z8wg',
    image:
      'https://media.which.gpp.io/prod/images/gm_medium_list_thumbnail/222f4a4449ce-best-cars-inline2.jpg',
    subheading:
      "We've independently tested hundreds of models and rounded up the best cars by class – from the latest electric vehicles to the best practical family cars",
    title: 'Best cars for 2025: Which? Best Buys and expert buying advice',
    type: 'advice',
  },
  {
    __typename: 'RecommendedArticle',
    href: 'https://www.which.co.uk/money/insurance/car-insurance/car-insurance/best-and-worst-car-insurance-a3PuA5f3sB6q',
    id: 'a3PuA5f3sB6q',
    image:
      'https://s3-eu-west-1.amazonaws.com/prod-media-which/prod/images/gm_medium_list_thumbnail/dac1505729e7-26-best-and-worst-car-insurance.jpg',
    subheading:
      'We surveyed more than 4,700 car insurance customers to discover the best car insurance companies and policies in the UK',
    title: 'Best car insurance companies in the UK 2025',
    type: 'advice',
  },
  {
    __typename: 'RecommendedArticle',
    href: 'https://www.which.co.uk/reviews/televisions/article/how-to-buy-the-best-tv-awTTN2d6a0u5',
    id: 'awTTN2d6a0u5',
    image:
      'https://media.which.gpp.io/prod/images/gm_medium_list_thumbnail/79da23e3dc1b-how-to-buy-the-best-tv-lg-oled42c34la.jpg',
    subheading:
      'Which? puts every TV through hundreds of tests to find the models that look and sound good enough for your home',
    title: 'Best TVs for 2025: Which? Best Buy TVs and expert buying advice',
    type: 'advice',
  },
  {
    __typename: 'RecommendedArticle',
    href: 'https://www.which.co.uk/reviews/mattresses/article/how-to-buy-the-best-mattress-atlAf8V9fiZN',
    id: 'atlAf8V9fiZN',
    image: 'https://media.which.gpp.io/prod/images/gm_preview/3604b4ec2d3f-mattress-lead.jpg',
    subheading:
      "We rigorously test pocket sprung, memory foam and hybrid mattresses to bring you our in-depth reviews. Use our expert advice to choose a Best Buy mattress you'll love sleeping on",
    title: "Best mattresses 2025: tried and tested for a perfect night's sleep",
    type: 'advice',
  },
]
